import React from 'react'

import type { MuiTheme as Theme } from '@paintscout/ui'
import { makeStyles } from '@paintscout/ui'

const useStyles = makeStyles((theme: Theme) => ({
  root: {},
  fill: {
    fill: theme.palette.primary.main
  },
  paper: {
    fill: '#fff',
    stroke: theme.palette.primary.main,
    strokeWidth: 5
  }
}))

export default function TwoColumnThumbnail({ ...props }) {
  const classes = useStyles(props)

  return (
    <svg viewBox="0 0 150 200">
      <rect x={0} y={75} width={67.5} height={20} className={classes.fill} />
      <rect x={0} y={105} width={67.5} height={20} className={classes.fill} />

      <rect x={82.5} y={75} width={67.5} height={20} className={classes.fill} />
      <rect x={82.5} y={105} width={67.5} height={20} className={classes.fill} />
    </svg>
  )
}
